import React from 'react';
import Text from '../Typography/Text';
import {
    CARD_CLASSES,
    CARD_MIN_HEIGHT,
    CARD_RADIUS,
    CONTENT_MIN_HEIGHT,
    DIVIDER_CLASSES,
    HEADER_HEIGHT,
} from './constants';

export interface EmptyLayoutProps {
    title?: string;
    children: React.ReactNode;
    centered?: boolean;
    uniformPadding?: boolean;
    headerActions?: React.ReactNode;
    background?: React.ReactNode;
    /** Demotes the default `main` landmark — pass e.g. `region` when the app owns its own. */
    role?: React.AriaRole;
    'aria-label'?: string;
    'aria-labelledby'?: string;
    className?: string;
    style?: React.CSSProperties;
}

const EmptyLayout: React.FC<EmptyLayoutProps> = ({
    title,
    children,
    centered = false,
    uniformPadding = false,
    headerActions,
    background,
    role,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    className = '',
    style,
}) => {
    const contentPadding = uniformPadding ? '8px' : centered ? '5vh 14vw' : '40px';

    return (
        <main
            className={`${CARD_CLASSES} ${className}`}
            style={{ borderRadius: CARD_RADIUS, minHeight: CARD_MIN_HEIGHT, ...style }}
            role={role}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
        >
            <div
                className={`flex items-center justify-between gap-4 ${DIVIDER_CLASSES}`}
                style={{
                    height: HEADER_HEIGHT,
                    paddingInlineStart: uniformPadding ? 8 : 28,
                    paddingInlineEnd: uniformPadding ? 8 : 16,
                }}
            >
                <div className="min-w-0">
                    {title ? <Text fontWeight="bold">{title}</Text> : null}
                </div>
                {headerActions}
            </div>

            <div
                className="relative"
                style={{ padding: contentPadding, minHeight: CONTENT_MIN_HEIGHT }}
            >
                {background ? (
                    <div aria-hidden="true" className="absolute bottom-0 left-0 h-1/2 w-full z-0">
                        {background}
                    </div>
                ) : null}
                <div className="relative z-10">{children}</div>
            </div>
        </main>
    );
};

export default EmptyLayout;
export { EmptyLayout };
